module.exports = __webpack_public_path__ + "static/media/mito14.0751c850.jpg";